// Coordina el modal "Actualizamos tu huso horario" entre Perfil (donde se
// guarda el cambio) y Agenda (donde se muestra el aviso tras la redirección).
// Se usa localStorage (no sessionStorage) a propósito: el aviso debe sobrevivir
// a un refresh de la página y solo desaparecer cuando la psicóloga lo cierra o
// cuando vuelve a cambiar el huso horario.
//
// Guarda también el huso anterior y el nuevo (no solo un flag booleano) para que
// el modal pueda mostrar la conversión real entre ambos, en vez de un texto fijo.
const PENDING_KEY = 'psi-tz-agenda-banner-pending';

export interface PendingTimezoneChange {
  prevTz: string;
  newTz: string;
}

export function markTimezoneAgendaBannerPending(prevTz: string, newTz: string): void {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({ prevTz, newTz }));
  } catch { /* noop */ }
}

export function getPendingTimezoneAgendaChange(): PendingTimezoneChange | null {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PendingTimezoneChange>;
    if (typeof parsed?.prevTz === 'string' && typeof parsed?.newTz === 'string') {
      return { prevTz: parsed.prevTz, newTz: parsed.newTz };
    }
    return null;
  } catch { return null; }
}

export function isTimezoneAgendaBannerPending(): boolean {
  return getPendingTimezoneAgendaChange() !== null;
}

export function dismissTimezoneAgendaBanner(): void {
  try { localStorage.removeItem(PENDING_KEY); } catch { /* noop */ }
}
